import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { KlarTilGodkendelseViewModel } from '../../store/models';
import { TilpasHandlingerTilGodkendelseService } from './tilpas-handlinger-til-godkendelse.service';

@Component({
    selector: 'app-tilpas-handlinger-til-godkendelse',
    templateUrl: './tilpas-handlinger-til-godkendelse.component.html',
    standalone: false
})
export class TilpasHandlingerTilGodkendelseComponent {
    tilpasHandlingerTilGodkendelse$ = this.tilpasHandlingerTilGodkendelseService.getTilpasHandlingerTilGodkendelseView();

    constructor(
        private tilpasHandlingerTilGodkendelseService: TilpasHandlingerTilGodkendelseService,
        private router: Router,
        private modal: NgbActiveModal
    ) {
    }

    onClose() {
        this.modal.close();
    }

    async onGotoGodkendelse(item: KlarTilGodkendelseViewModel) {
        await this.router.navigate(['clients', item.kid, 'regnskabsaar', item.regnskabsaarId, 'sag', item.sagId, 'tilpashandlinger']);
        this.modal.close();
    }
}
